import { LOGIN, LOGOUT } from './types';
import { CLEAR_PARAMS } from '../route-params/types';

export const login = (payload) => (dispatch) => {
    dispatch({ type: LOGIN, payload });
};

export const logout = () => (dispatch) => {
    dispatch({ type: CLEAR_PARAMS })
    dispatch({ type: LOGOUT });
};